import { isGhostLogin as isGhost } from 'services/auth/auth-storage-manager';

/**
 * @deprecated Use `isGhostLogin` from `services/auth/auth-storage-manager` instead.
 */
export function isGhostLogin(): boolean {
  return isGhost();
}
